// The portfolio's address before EPD-12500. The edge 301s /p/<slug> to
// /portfolio/<slug> (apps/web/worker.ts); this redirect covers the app without
// the edge worker in front (local dev). Links creators already shared and
// Media Kits filled before the move still point here.

import { redirectToPortfolioAddress } from "@/lib/portfolio/public-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/p/$profileSlug")({
  beforeLoad: ({ params, location }) =>
    redirectToPortfolioAddress({ slug: params.profileSlug, location }),
});
